import { toSigned180ScaleDegree } from '../..';
import { DoubleTouchBase, TouchData } from '../data';
import { ZEDCamera } from '../ZEDCamera';
import { checkCrossDoubleTouch, getAngleBetweenTouch, rotateAroundYAxisWithPivot } from '../ZEDCameraInputHelper';
import { InputCanvasProps } from '../ZEDCameraInputManager';
import { Vector3 } from '@babylonjs/core';

let previousAngle: number = 0;
let pivot: Vector3 | undefined = undefined;
export const DoubleTouchCrossRotation: DoubleTouchBase = {
  type: 'DoubleTouch',
  touchCount: 2,
  key: 'DoubleTouchCross',
  name: 'DoubleTouchCrossRotation',
  option: {},
  attachControl(
    _camera: ZEDCamera,
    _canvasProps: InputCanvasProps,
    _isMobileOrTablet: boolean,
    _noPreventDefault?: boolean | undefined
  ) {},
  detachControl(_camera: ZEDCamera, _isMobileOrTablet: boolean) {},
  checkInputs(_camera: ZEDCamera) {},
  reset() {},
  checkCondition(_camera: ZEDCamera, touchData: TouchData[]) {
    previousAngle = getAngleBetweenTouch(touchData);
    return checkCrossDoubleTouch(touchData);
  },
  onTouchStart(camera, touchData, _canvasProps) {
    camera.stopPlayingAnimation();
    const t1 = touchData[0]?.point;
    const t2 = touchData[1]?.point;
    if (!t1 || !t2) return;

    const center = t1.add(t2).scale(0.5);
    const pick = camera.getScene().pick(center.x, center.y);
    if (pick && pick.pickedPoint) pivot = pick.pickedPoint;
  },
  onTouchMoved(camera: ZEDCamera, touchData: TouchData[], _canvasProps: InputCanvasProps) {
    const t1 = touchData[0]?.point;
    const t2 = touchData[1]?.point;
    if (!t1 || !t2) return;

    const angle = getAngleBetweenTouch(touchData);
    const diff = toSigned180ScaleDegree(previousAngle - angle);

    previousAngle = angle;

    if (pivot) rotateAroundYAxisWithPivot(camera, diff, pivot);
  },
  onTouchEnd(_camera: ZEDCamera, _touchData: TouchData[], _canvasProps: InputCanvasProps) {
    previousAngle = 0;
    pivot = undefined;
  },
};
